/* eslint-disable */

/******************************************************************************
  * This file is auto-generated. Do not edit this file manually.
  * You can run `yarn cli generate:translations` to re-generate this file.
******************************************************************************/


import { IntlProvider as CoreIntlProvider, type Formats } from 'use-intl'
import React from 'react';
import { assertNever } from '~utilities'
export { useTranslations, useFormatter, useLocale } from 'use-intl'
import source from '../../translations/source.json';

export const locales = ['de-AT', 'de-DE', 'de-CH', 'fr-CH', 'it-CH', 'nl-NL', 'es-ES', 'en-GB', 'en-US', 'fr-FR', 'it-IT', 'fr-BE', 'nl-BE'] as const
export const languages = ['de', 'fr', 'it', 'nl', 'es', 'en'] as const
export const defaultLocale = 'en-GB'
export const defaultLanguage = 'en'
export type Locale = typeof locales[number]
export type Language = typeof languages[number]
export const intlFormats = {
  dateTime: {
    'date-short': {
      day: "numeric",
      month: "numeric",
      year: "numeric"
    },
    "date-medium": {
      weekday: "short",
      day: "numeric",
      month: "numeric",
      year: "numeric"
    },
    "date-long": {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric"
    },
    'time': {
      hour: "numeric",
      minute: "2-digit",
    },
    'datetime-short': {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    },
    "datetime-medium": {
      weekday: "short",
      day: "numeric",
      month: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    },
    "datetime-long": {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    },
  }
} satisfies Formats

export function extractLanguageFromLocale(locale: Locale): Language {
  return locale.split('-')[0] as Language
}

export const getDefaultLocaleForLanguage = (language: Language): Locale => {
  switch (language) {
    case 'de':
      return 'de-DE'
    case 'en':
      return 'en-GB'
    case 'fr':
      return 'fr-FR'
    case 'it':
      return 'it-IT'
    case 'nl':
      return 'nl-NL'
    case 'es':
      return 'es-ES'
    default:
      return assertNever(language)
  }
}

export async function loadTranslations(locale: string) {
  const language = extractLanguageFromLocale(locale as Locale)
  switch(language) {
    case 'de':
      return (await import(`../../translations/translated/de.json`)).default
    case 'fr':
      return (await import(`../../translations/translated/fr.json`)).default
    case 'it':
      return (await import(`../../translations/translated/it.json`)).default
    case 'nl':
      return (await import(`../../translations/translated/nl.json`)).default
    case 'es':
      return (await import(`../../translations/translated/es.json`)).default
    case 'en':
      return (await import(`../../translations/translated/en.json`)).default
    default:
      return (await import(`../../translations/translated/en.json`)).default
  }
}

interface I18nClientProviderProps {
  locale: string
  translations: typeof source
}

export const IntlProvider = ({ translations, locale, children }: React.PropsWithChildren<I18nClientProviderProps>) => {
  return <CoreIntlProvider locale={locale} formats={intlFormats} messages={translations} timeZone={'Europe/Vienna'}>
    {children}
  </CoreIntlProvider>
}
